export default __webpack_public_path__ + "static/media/banner.21200c2c.png";